import React from 'react'
import './index.scss'

import Dialog from '../../../Components/Dialog'

import FollowTips from '../FollowTips'

import history from '../../../History'
import {getAllUrlParams, json2keyval, refreshPage} from '../../../Utils/Utils'

export default function BindResultDialog(props) {
  let { visible, setVisible, status, info } = props
  
  //test
  // status = 1000031

  // 组所属归类
  // 状态错综复杂，需要对照文档
  const group = {
    0: 'zero-success',
    1: 'success', 4: 'SF', 10: 'SA', 12: 'SF',
    2: 'SA',
    3: 'SA',
    13: 'SA', 14: 'SFW', 15: 'fail', 16: 'SW', 17: 'SF',
    18: 'SA', 19: 'SF', 20: 'GSA', 21: 'success', 22: 'GSF',
    23: 'GSA', 24: 'GSF', 25: 'GSE', 26: 'fail', 30: '',
    31: '', 32: '', 33: 'fail', 40: 'fail', 50: 'zero',
    '-1': 'cancel',
    51: 'cancel', 900: 'cancel', 901: 'black', 1000030: 'bs1', 1000031: 'bs2', 1000032: 'bs3',
    70: 'SBcq', 71: 'SAcq', 72: 'SFcq'
  }

  let fStatus = group[status] || 'fail'

  const statusMap = {
    // 简写中，S代表成功，F代表不通过，E代表失败，A代表审核中，W代表还没有作品,第一个代表绑定状态，第二个代表入驻状态
    // 首字母G代表认领的
    //第二个字母B代表资料需要补充
    //cq表示词曲音乐人已入驻
    //SFW:入驻审核未通过，修改作品
    'zero-success': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false);
            refreshPage()
          }
        }
      }]
    },
    'zero': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '立即入驻/认领', fn: () => {
          setVisible(false);
          // if (!~window.location.hash.indexOf('enter')) {
          // history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
          history.go('/enter-choose')
          // }
          //window.location.reload()
        }
      }]
    },
    'fail': {
      title: '绑定失败',
      btns: [{
        text: '立即入驻/认领', fn: () => {
          setVisible(false);
          // if (!~window.location.hash.indexOf('enter')) {
          // history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
          history.go('/enter-choose')
          // }
        }
      }]
    },
    'success': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: info.role == 2 ? '机构主页' : '音乐人主页',
        fn: () => {
          setVisible(false);
          //透传所有url参数
          let params = getAllUrlParams();
          let url = 'https://h5.kugou.com/musicianService/v-6d9959c0/index.html?type=1&norule=1'+(Object.keys(params).length?'&'+json2keyval(params):'')
          window.$goToPage(
            info.role == 2
              ? 'https://activity.kugou.com/vo-activity/bd0c1520-722a-11ea-bd83-e73dc97ba287/index.html'
              : url
          )
        }
      }]
    },
    'SA': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
            //作用：绑定成功后修改status，不然刷新后Enter里的statusOp传的status值未改变
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            refreshPage()
          }
          if (!~window.location.hash.indexOf('enter')) {
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            console.log( 'url:' + window.location.href );
            window.$toResultTag = true
          }
        }
      }]
    },
    'SBcq': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
            //作用：绑定成功后修改status，不然刷新后Enter里的statusOp传的status值未改变
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            console.log(status);
            refreshPage()
          }
          if (!~window.location.hash.indexOf('enter')) {
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            console.log( 'url:' + window.location.href );
            window.$toResultTag = true
          }
        }
      }]
    },
    'SAcq': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
            //作用：绑定成功后修改status，不然刷新后Enter里的statusOp传的status值未改变
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            refreshPage()
          }
          if (!~window.location.hash.indexOf('enter')) {
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            console.log( 'url:' + window.location.href );
            window.$toResultTag = true
          }
        }
      }]
    },
    'SFcq': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
            //作用：绑定成功后修改status，不然刷新后Enter里的statusOp传的status值未改变
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            refreshPage()
          }
          if (!~window.location.hash.indexOf('enter')) {
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            console.log( 'url:' + window.location.href );
            window.$toResultTag = true
          }
        }
      }]
    },
    'SF': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            refreshPage()
          }

          //旧方式：未进入enter的进入enter
          //src\Pages\Enter\index.js resultOp里添加statusOp
          /* if (!~window.location.hash.indexOf('enter')) {
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            console.log( 'url:' + window.location.href );
            window.$toResultTag = true
          } */
        }
      }]
    },
    'SFW': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            refreshPage()
          }
          if (!~window.location.hash.indexOf('enter')) {
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            console.log( 'url:' + window.location.href );
            window.$toResultTag = true
          }
        }
      }]
    },
    'SW': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            refreshPage()
          }
          if (!~window.location.hash.indexOf('enter')) {
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            console.log( 'url:' + window.location.href );
            window.$toResultTag = true
          }
        }
      }]
    },
    'GSA': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            refreshPage()
          }
          if (!~window.location.hash.indexOf('enter')) {
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            console.log( 'url:' + window.location.href );
            window.$toResultTag = true
          }
        }
      }]
    },
    'GSF': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            refreshPage()
          }
          if (!~window.location.hash.indexOf('enter')) {
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            console.log( 'url:' + window.location.href );
            window.$toResultTag = true
          }
        }
      }]
    },
    'GSE': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            refreshPage()
          }
          if (!~window.location.hash.indexOf('enter')) {
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            console.log( 'url:' + window.location.href );
            window.$toResultTag = true
          }
        }
      }]
    },
    // 已注销
    'cancel': {
      title: `类型：${info.roleStr}`,
      //blue: true,
      leftTop: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
          }
        }
      }]
    },
    //被冻结
    'black': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
            history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
            refreshPage()
          }
        }
      }]
    },
    'frozen': {
      title: '绑定成功',
      blue: true,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
          }
        }
      }]
    },
    // 其他业务情况
    'bs1': {
      title: '绑定失败',
      // desc: '您的手机号码与腾讯音乐人多个账号关联，请先登录腾讯音乐人平台确认账号。',
      desc: info.message,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
          }
        }
      }]
    },
    'bs2': {
      title: '绑定失败',
      // desc: '您的手机号码已与其他腾讯音乐人账号绑定！',
      desc: info.message,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
          }
        }
      }]
    },
    'bs3': {
      title: '绑定失败',
      // desc: '您的酷狗账号已与腾讯音乐人账号绑定！',
      desc: info.message,
      btns: [{
        text: '知道了', fn: () => {
          if (window.toBind) {
            if (window.LC.isIOS) {
              window.LC.mobileCall(158, { type: 1 })
            } else {
              window.LC.mobileCall(158, { type: 2 })
            }
          } else {
            setVisible(false)
          }
        }
      }]
    }
  }

  let target = statusMap[fStatus]


  function imgOnError(e) {
    let target = e.target
    target.onerror = null;
    target.src = 'https://webimg.kgimg.com/770af1944474f8cc548d1a59723a54aa.png'
  }

  let titleType = {
    color: target.blue ? '#0090ff' : '#000',
    marginBottom: target.blue ? '0.5rem' : '0.2rem'
  }
  if ( target.leftTop ){
    titleType = {
      color: '#0090ff',
      marginBottom: '0.44rem',
      marginTop: '0.3rem',
      paddingLeft: '0.3rem',
      textAlign: 'left'
    }
  }

  return (<Dialog visible={visible} setVisible={setVisible} btns={target.btns} title={target.title} titleStyle={titleType}>
    <div className="BindResultDialog">
      {!!~['success','zero-success'].indexOf(fStatus) && <section className="portrait">
        < img src={info.pic || 'https://webimg.kgimg.com/770af1944474f8cc548d1a59723a54aa.png'} alt="" onError={imgOnError} />
        <span className={"star" + (!!~['success'].indexOf(fStatus) ? '' : ' off')}></span>
      </section>}
      {!!~['fail'].indexOf(fStatus) && <section className="alreadyBind">未查询到该手机号的入驻记录~</section>}
      {!!~['zero'].indexOf(fStatus) && <section className="alreadyBind">请补齐您的实名认证信息，完成入驻！</section>}
      {/* <section className="alreadyBind">该手机号绑定的账号已被他人绑定！</section> */}
      {!!~['success','zero-success'].indexOf(fStatus) && <section className="name">{info.name||info.userName}</section>}
      {!!~['success','zero-success'].indexOf(fStatus) && info.role === 1 && <section className="welcome">欢迎您！音乐人</section>}
      {!!~['SW'].indexOf(fStatus) && <section className="audit">您还未上传作品，请移步酷狗音乐人网页(musician.kugou.com)上传作品</section>}
      {/* {!!~[18].indexOf(fStatus) && <section className="audit">您已提交作品，管理员正在审核中！请耐心等待~</section>} */}
      {!!~['SA', 'GSA'].indexOf(fStatus) && <section className="noPassAudit ing">您的{fStatus === 'SA' ? '入驻' : '认领申请'}正在审核中，请耐心等待！</section>}
      {!!~['SF'].indexOf(fStatus) && <section className="noPassAudit">您绑定账号的入驻审核未通过！{info.role === 1 ? '请前往电脑端(musician.kugou.com)修改资料后重新提交审核。':''}</section>}
      {!!~['SFW'].indexOf(fStatus) && <section className="noPassAudit">您绑定账号的入驻审核未通过！请移步酷狗音乐人网页(musician.kugou.com)修改作品后重新提交审核。</section>}
      {!!~['GSF'].indexOf(fStatus) && <section className="noPassAudit ren">您认领的账号审核未通过！请前往电脑端(musician.kugou.com)修改资料后重新提交审核。</section>}
      {!!~['GSE'].indexOf(fStatus) && <section className="noPassAudit ren">您认领账号失败！请前往电脑端(musician.kugou.com)修改资料后重新提交审核。</section>}
      {!!~['cancel'].indexOf(fStatus) && <section className="noPassAudit ren">该手机号绑定的账号已注销！</section>}
      {!!~['black'].indexOf(fStatus) && <section className="noPassAudit ren">您的账号已被冻结！</section>}
      {!!~['SBcq'].indexOf(fStatus) && <section className="noPassAudit ren">您绑定的账号需完善歌手资料，审核通过后即在酷狗客户端展示您歌手页</section>}
      {!!~['SAcq'].indexOf(fStatus) && <section className="noPassAudit ren">您绑定的账号正在审核中，请耐心等待！</section>}
      {!!~['SFcq'].indexOf(fStatus) && <section className="noPassAudit ren">您绑定账号的入驻审核未通过！</section>}
      {!!~['bs1', 'bs2', 'bs3'].indexOf(fStatus) && <section className="noPassAudit ren">{target.desc}</section>}
      {!!~['SA', 'SF', 'SFW', 'GSA', 'GSF', 'GSE', 'frozen', 'bs1', 'bs2', 'bs3'].indexOf(fStatus) && <section className="followContainer">
        <FollowTips />
      </section>}

      {!!~['fail', 'zero'].indexOf(fStatus) && <section className="goTips">
        <p>1.如您还未入驻，可点击立即入驻酷狗音乐人</p>
        <p>2.如您已更换手机号，请登录腾讯音乐人平台</p>
        <p><span>y.tencentmusic.com</span>修改手机号后再进行绑定</p>
      </section>}

    </div>
  </Dialog >)
}